<template>
  <div style="margin: 0 auto;width: 100%;">
    <Header/>
    <AthleteRanking/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import AthleteRanking from './components/AthleteRanking'
import Footer from '../layout/Footer'
export default {
  components: {
    Header,
    AthleteRanking,
    Footer
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ProgramRank.vue